import React, { FC, useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { createPortal } from 'react-dom';

const BodyConfetti: FC<{ active: boolean }> = ({ active }) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateSize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  if (typeof document === 'undefined') return null;

  return createPortal(
    active ? (
      <Confetti
        recycle={false}
        width={size.width}
        height={size.height}
        numberOfPieces={400}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          pointerEvents: 'none', // so UI stays clickable
          zIndex: 999999, // ✅ bring to front
        }}
      />
    ) : null,
    document.body,
  );
};

export default BodyConfetti;
